module.exports = __webpack_public_path__ + "assets/compare_arrows_white.1643e4c0ada2ae5eeabbbb5e7f484745.svg";